/* Component Dependencies */
var expiredSessionTemplate = require('templates/expiredSession.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'expiredSession',
  template: {
    'expiredSession': expiredSessionTemplate
  }
});
